import { loginError, loginSuccess, logoutSuccess } from "./reducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { RootState } from "slices";
import { getFirebaseBackend } from "helpers/firebase_helper";
import { login } from "services/auth.service";

interface User {
  email: string;
  password: string;
}

export const loginUser = (
  user: User,
  history: any
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
  try {
    let response: any;
    response = await login(user.email, user.password);

    const respUser = response.user

    localStorage.setItem("authUser", JSON.stringify(respUser));
    localStorage.setItem("authProject", JSON.stringify(response.project));
    localStorage.setItem("accessToken", response.accessToken);

    if (response) {
      dispatch(loginSuccess(response))

      doLoginRoute(history)
    }
  } catch (error) {

    dispatch(loginError(error));
  }
};

export const doLoginRoute = (history: any) => {

  const user = JSON.parse(localStorage.getItem("authUser") as string)
  const roleAccess = user.roleAccess

  if (roleAccess['dashboard']) {
    history("/dashboard")
    return
  } else if (roleAccess['ecommerce']) {
    history("/apps-ecommerce-orders")
    return
  } else {
    history("/apps-booking")
    return
  }
}

export const logoutUser = () => async (dispatch: Dispatch) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("accessToken");
    localStorage.clear();

    let fireBaseBackend = await getFirebaseBackend();

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutSuccess(response));
    } else {
      dispatch(logoutSuccess(true));
    }
  } catch (error) {
    dispatch(loginError(error));
  }
}


export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
  try {
    let response: any;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }

    const socialData = await response;

    if (socialData) {
      sessionStorage.setItem("authUser", JSON.stringify(socialData));
      dispatch(loginSuccess(socialData));
      history('/dashboard');
    }

  } catch (error) {
    dispatch(loginError(error));
  }
}